<template>
    <card class="spaced typo">
        
        <h2 class="text-white mb-4">
            {{ $t('xapi.common.activity-profiles') }}
        </h2>

        <form @submit.prevent @keydown="filters.errors.clear($event.target.name)">

            <div class="form-row">

                <label class="col-md-1 col-form-label text-md-right text-left pb-0">
                    {{ $t('xapi.common.profile-id') }}
                </label>

                <base-input class="col-md-11"
                    :placeholder="$t('xapi.common.search.id-placeholder')"
                    v-model="filters.profileId"
                    name="profileId"
                    :error="filters.errors.get('profileId')">
                </base-input>
            </div>

            <div class="form-row">

                <label class="col-md-1 col-form-label text-md-right text-left pb-0">
                    {{ $t('xapi.common.activity-id') }}
                </label>

                <base-input class="col-md-11"
                    :placeholder="$t('xapi.common.search.iri-placeholder')"
                    v-model="filters.activityId"
                    name="activityId"
                    :error="filters.errors.get('activityId')">
                </base-input>
            </div>

            <div class="text-center pt-1">
                <base-button type="primary" native-type="submit" @click="apply">
                    {{ $t('common.apply') }}
                </base-button>

                <base-button type="primary" native-type="submit" link @click="reset">
                    {{ $t('common.reset') }}
                </base-button>
            </div>

        </form>
    </card>
</template>

<script>
    export default {

        data() {
            return {
                loader: this.$xapi.loaders.activityProfiles,
                filters: this.$xapi.filters.activityProfiles,
            }
        },

        created() {
            this.$xapi.filters.activityProfiles.attach(this)
        },

        methods: {

            apply() {
                this.loader.firstLoad()
            },

            reset() {
                this.filters.reset()
                this.loader.firstLoad()
            }
        }
    }
</script>
